export default "__VITE_ASSET__B_mLJ$7B__"